import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { ActionStepStatus, ActionStepType } from 'constants/aiChat';

import ActionStep from '../../../../ActionStep';

import { resolveActionStepDescription } from './ActionStepContent.utils';

const ActionStepContent = ({ contentProps }) => {
  const { label, status, summary, errorMessage, actionStepType, toolName } = contentProps;

  return (
    <ActionStep
      actionStepType={actionStepType}
      description={resolveActionStepDescription(status, summary, errorMessage)}
      status={status}
      title={label}
      toolName={toolName}
    />
  );
};

ActionStepContent.propTypes = {
  contentProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(ActionStepStatus)).isRequired,
    actionStepType: PropTypes.oneOf(Object.values(ActionStepType)),
    summary: PropTypes.string,
    errorMessage: PropTypes.string,
    startTime: PropTypes.string,
    toolName: PropTypes.string,
    elapsedMs: PropTypes.number,
    progressText: PropTypes.string,
    sequenceNumber: PropTypes.number,
    parentGroupId: PropTypes.string,
  }).isRequired,
};

export default memo(ActionStepContent);
